// Auto-generated types for LaunchToken
// DO NOT EDIT MANUALLY

// Function types
export type AirdropModuleParams = {  };
export type AirdropModuleReturn = `0x${string}`;

export type AllowanceParams = { owner: `0x${string}`, spender: `0x${string}` };
export type AllowanceReturn = bigint;

export type AntiSnipeBPSParams = {  };
export type AntiSnipeBPSReturn = bigint;

export type AntiSnipeStartBPSParams = {  };
export type AntiSnipeStartBPSReturn = number;

export type AntiSnipeWindowParams = {  };
export type AntiSnipeWindowReturn = number;

export type ApproveParams = { spender: `0x${string}`, value: bigint };
export type ApproveReturn = boolean;

export type BalanceOfParams = { account: `0x${string}` };
export type BalanceOfReturn = bigint;

export type BuyExactInParams = { minTokensOut: bigint, to: `0x${string}`, deadline: bigint };
export type BuyExactInReturn = bigint;

export type BuyExactOutParams = { tokensOut: bigint, to: `0x${string}`, deadline: bigint };
export type BuyExactOutReturn = bigint;

export type BuybackFeeBPSParams = {  };
export type BuybackFeeBPSReturn = number;

export type BuybackThresholdParams = {  };
export type BuybackThresholdReturn = bigint;

export type CreationBlockParams = {  };
export type CreationBlockReturn = bigint;

export type CreatorParams = {  };
export type CreatorReturn = `0x${string}`;

export type DecimalsParams = {  };
export type DecimalsReturn = number;

export type DevBuyModuleParams = {  };
export type DevBuyModuleReturn = `0x${string}`;

export type ExecuteBuybackParams = { deadline: bigint };
export type ExecuteBuybackReturn = bigint;

export type FactoryParams = {  };
export type FactoryReturn = `0x${string}`;

export type FeeBPSParams = {  };
export type FeeBPSReturn = number;

export type FeeRecipientParams = {  };
export type FeeRecipientReturn = `0x${string}`;

export type FeeRecipientAtParams = { index: bigint };
export type FeeRecipientAtReturn = [`0x${string}`, number];

export type FeeRecipientsLengthParams = {  };
export type FeeRecipientsLengthReturn = bigint;

export type FloorPriceParams = {  };
export type FloorPriceReturn = bigint;

export type FloorPriceLiveParams = {  };
export type FloorPriceLiveReturn = bigint;

export type FloorReserveParams = {  };
export type FloorReserveReturn = bigint;

export type FloorShareBPSParams = {  };
export type FloorShareBPSReturn = number;

export type GraduateParams = {  };
export type GraduateReturn = void;

export type GraduatedParams = {  };
export type GraduatedReturn = boolean;

export type GraduationQuoteThresholdParams = {  };
export type GraduationQuoteThresholdReturn = bigint;

export type KParams = {  };
export type KReturn = bigint;

export type MigratorParams = {  };
export type MigratorReturn = `0x${string}`;

export type ModulesParams = {  };
export type ModulesReturn = [`0x${string}`, `0x${string}`, `0x${string}`, `0x${string}`];

export type NameParams = {  };
export type NameReturn = string;

export type QuoteBuyExactInParams = { grossIn: bigint };
export type QuoteBuyExactInReturn = bigint;

export type QuoteBuyExactOutParams = { tokensOut: bigint };
export type QuoteBuyExactOutReturn = bigint;

export type QuoteReserveParams = {  };
export type QuoteReserveReturn = bigint;

export type QuoteSellExactInParams = { tokensIn: bigint };
export type QuoteSellExactInReturn = bigint;

export type QuoteSellExactOutParams = { quoteOut: bigint };
export type QuoteSellExactOutReturn = bigint;

export type RedeemAtFloorParams = { amount: bigint, to: `0x${string}`, deadline: bigint };
export type RedeemAtFloorReturn = bigint;

export type RedeemableSupplyParams = {  };
export type RedeemableSupplyReturn = bigint;

export type SellExactInParams = { tokensIn: bigint, minQuoteOut: bigint, to: `0x${string}`, deadline: bigint };
export type SellExactInReturn = bigint;

export type SellExactOutParams = { quoteOut: bigint, maxTokensIn: bigint, to: `0x${string}`, deadline: bigint };
export type SellExactOutReturn = bigint;

export type SnipeSurplusParams = {  };
export type SnipeSurplusReturn = bigint;

export type SpotPriceParams = {  };
export type SpotPriceReturn = bigint;

export type SymbolParams = {  };
export type SymbolReturn = string;

export type TokenReserveParams = {  };
export type TokenReserveReturn = bigint;

export type TotalSupplyParams = {  };
export type TotalSupplyReturn = bigint;

export type TradingStoppedParams = {  };
export type TradingStoppedReturn = boolean;

export type TransferParams = { to: `0x${string}`, value: bigint };
export type TransferReturn = boolean;

export type TransferFromParams = { from: `0x${string}`, to: `0x${string}`, value: bigint };
export type TransferFromReturn = boolean;

export type TreasuryReserveParams = {  };
export type TreasuryReserveReturn = bigint;

export type VaultModuleParams = {  };
export type VaultModuleReturn = `0x${string}`;

export type VirtualQuoteReserveParams = {  };
export type VirtualQuoteReserveReturn = bigint;

export type VirtualTokenReserveParams = {  };
export type VirtualTokenReserveReturn = bigint;

// Event types
export interface AntiSnipeFeeEvent {
  trader: `0x${string}`; // indexed
  snipeAmt: bigint;
  bpsApplied: bigint;
  blocksElapsed: bigint;
}

export interface ApprovalEvent {
  owner: `0x${string}`; // indexed
  spender: `0x${string}`; // indexed
  value: bigint;
}

export interface BuybackExecutedEvent {
  caller: `0x${string}`; // indexed
  treasurySpent: bigint;
  floorContribution: bigint;
  curveSpent: bigint;
  tokensBurned: bigint;
  floorPrice: bigint;
}

export interface FloorRaisedEvent {
  floorPrice: bigint;
  floorReserve: bigint;
  redeemableSupply: bigint;
}

export interface GraduatedEvent {
  quoteRaised: bigint;
  finalSupply: bigint;
  discoveryEth: bigint;
  discoveryTokens: bigint;
  lockedFloor: bigint;
}

export interface RedeemedEvent {
  holder: `0x${string}`; // indexed
  to: `0x${string}`; // indexed
  tokenAmount: bigint;
  quoteOut: bigint;
  floorPrice: bigint;
}

export interface TradeEvent {
  trader: `0x${string}`; // indexed
  to: `0x${string}`; // indexed
  isBuy: boolean;
  quoteAmount: bigint;
  tokenAmount: bigint;
  feeAmount: bigint;
  floorAmount: bigint;
  newQuoteReserve: bigint;
  newTokenReserve: bigint;
}

export interface TransferEvent {
  from: `0x${string}`; // indexed
  to: `0x${string}`; // indexed
  value: bigint;
}

// ABI type for viem
export const LaunchTokenAbi = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "p",
        "type": "tuple",
        "internalType": "struct LaunchToken.InitParams",
        "components": [
          {
            "name": "name",
            "type": "string",
            "internalType": "string"
          },
          {
            "name": "symbol",
            "type": "string",
            "internalType": "string"
          },
          {
            "name": "creator",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "feeRecipients",
            "type": "address[]",
            "internalType": "address[]"
          },
          {
            "name": "feeRewardBps",
            "type": "uint16[]",
            "internalType": "uint16[]"
          },
          {
            "name": "vaultModule",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "airdropModule",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "devBuyModule",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "migrator",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "virtualQuoteReserve",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "virtualTokenReserve",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "feeBPS",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "floorShareBPS",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "antiSnipeStartBPS",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "antiSnipeWindow",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "graduationQuoteThreshold",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "buybackFeeBPS",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "buybackThreshold",
            "type": "uint256",
            "internalType": "uint256"
          }
        ]
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "airdropModule",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "allowance",
    "inputs": [
      {
        "name": "owner",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "spender",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "antiSnipeBPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "antiSnipeStartBPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "antiSnipeWindow",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "approve",
    "inputs": [
      {
        "name": "spender",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "balanceOf",
    "inputs": [
      {
        "name": "account",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "buyExactIn",
    "inputs": [
      {
        "name": "minTokensOut",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tokensOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "buyExactOut",
    "inputs": [
      {
        "name": "tokensOut",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "grossIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "buybackFeeBPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "buybackThreshold",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "creationBlock",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "creator",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "decimals",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "devBuyModule",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "executeBuyback",
    "inputs": [
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tokensBurned",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "factory",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "feeBPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "feeRecipient",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "feeRecipientAt",
    "inputs": [
      {
        "name": "index",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "recipient",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "rewardBps",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "feeRecipientsLength",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "floorPrice",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "floorPriceLive",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "floorReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "floorShareBPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "graduate",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "graduated",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "graduationQuoteThreshold",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "k",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "migrator",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "modules",
    "inputs": [],
    "outputs": [
      {
        "name": "vault",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "airdrop",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "devBuy",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "migrationModule",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "name",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteBuyExactIn",
    "inputs": [
      {
        "name": "grossIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tokensOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteBuyExactOut",
    "inputs": [
      {
        "name": "tokensOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "grossIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteSellExactIn",
    "inputs": [
      {
        "name": "tokensIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "quoteOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteSellExactOut",
    "inputs": [
      {
        "name": "quoteOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tokensIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "redeemAtFloor",
    "inputs": [
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "quoteOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "redeemableSupply",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "sellExactIn",
    "inputs": [
      {
        "name": "tokensIn",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "minQuoteOut",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "quoteOut",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "sellExactOut",
    "inputs": [
      {
        "name": "quoteOut",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "maxTokensIn",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "deadline",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "tokensIn",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "snipeSurplus",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "spotPrice",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "symbol",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "tokenReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "totalSupply",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "tradingStopped",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "transfer",
    "inputs": [
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "transferFrom",
    "inputs": [
      {
        "name": "from",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "treasuryReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "vaultModule",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "virtualQuoteReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "virtualTokenReserve",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "AntiSnipeFee",
    "inputs": [
      {
        "name": "trader",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "snipeAmt",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "bpsApplied",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "blocksElapsed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Approval",
    "inputs": [
      {
        "name": "owner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "spender",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BuybackExecuted",
    "inputs": [
      {
        "name": "caller",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "treasurySpent",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "floorContribution",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "curveSpent",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "tokensBurned",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "floorPrice",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "FloorRaised",
    "inputs": [
      {
        "name": "floorPrice",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "floorReserve",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "redeemableSupply",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Graduated",
    "inputs": [
      {
        "name": "quoteRaised",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "finalSupply",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "discoveryEth",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "discoveryTokens",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "lockedFloor",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Redeemed",
    "inputs": [
      {
        "name": "holder",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "tokenAmount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "quoteOut",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "floorPrice",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Trade",
    "inputs": [
      {
        "name": "trader",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "isBuy",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      },
      {
        "name": "quoteAmount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "tokenAmount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "feeAmount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "floorAmount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "newQuoteReserve",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "newTokenReserve",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Transfer",
    "inputs": [
      {
        "name": "from",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "BelowBuybackThreshold",
    "inputs": []
  },
  {
    "type": "error",
    "name": "CurveExhausted",
    "inputs": []
  },
  {
    "type": "error",
    "name": "DeadlinePassed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ERC20InsufficientAllowance",
    "inputs": [
      {
        "name": "spender",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "allowance",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "needed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "ERC20InsufficientBalance",
    "inputs": [
      {
        "name": "sender",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "balance",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "needed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "ERC20InvalidApprover",
    "inputs": [
      {
        "name": "approver",
        "type": "address",
        "internalType": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "ERC20InvalidReceiver",
    "inputs": [
      {
        "name": "receiver",
        "type": "address",
        "internalType": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "ERC20InvalidSender",
    "inputs": [
      {
        "name": "sender",
        "type": "address",
        "internalType": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "ERC20InvalidSpender",
    "inputs": [
      {
        "name": "spender",
        "type": "address",
        "internalType": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "ETHTransferFailed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ExceedsRedeemable",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FloorNotSet",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FloorWouldDilute",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InsufficientValue",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidFeeSplit",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotGraduatable",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ReentrancyGuardReentrantCall",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SlippageExceeded",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TradingHalted",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ZeroAmount",
    "inputs": []
  }
] as const;

export type LaunchTokenAbiType = typeof LaunchTokenAbi;
